import { getAdvertorialAttributeByCard } from '../../utils'

import { CompareCredit } from '../../../types/compare-credit'

export const AttributeRendererWithSlug = (
  referencedCards: CompareCredit.FormattedCard[],
) => {
  const AttributeRendererWithSlugRender: React.FC<{
    value: {
      attribute: string
      slug: string
      bonusRewards: string
    }
  }> = ({ value }) => {
    const cardSlug = value.slug
    const card = referencedCards.find(
      ({ slug }: { slug: string }) => slug === cardSlug,
    )

    return card ? (
      getAdvertorialAttributeByCard({
        card,
        ...value,
      })
    ) : (
      <></>
    )
  }
  return AttributeRendererWithSlugRender
}
